import { Collection } from 'es6/components/collection'
import { Defaults } from 'es-decorators'
import { entryScriptName } from 'init/entry-script-name'

/**
 * Коллекция для поисковых подсказок
 */
@Defaults({
  url: `${entryScriptName}/api/v3/search-dropdown/`,
})
export class SearchTips extends Collection {}
